<template>
  <transition name="fade" mode="out-in">
    <div>
      <Preloader v-if="status === false"></Preloader>
      <div class="box-table"
        v-if="!emptywithdrawal">
        <div class="horizontal-responsive">
          <button class="button"
            @click="$modal.show('virtualaccounts-debits')"
            v-if="$store.getters.getUserBalance.balance > 0"
            >Solicitar retiro</button>
          <modal
            name="virtualaccounts-debits"
            classes="modal-investment v--modal-box v--modal"
            height="auto" width="100%" :maxWidth="600" :adaptive="true">
            <DashboardVirtualAccountsModalDebit
                v-on:updateTableWithdrawal = 'getUserWithdrawal'
            >
            </DashboardVirtualAccountsModalDebit>
          </modal>
          <table class="table-style">
            <tr>
              <th>Clabe</th>
              <th>
                <a href="#"
                  @click.prevent="sortFunction('-clabe', 'clabe')" v-if="sortValues.clabe">
                  Banco</a>
                <a href="#"
                  @click.prevent="sortFunction('clabe', 'clabe')" v-if="!sortValues.clabe">
                  Banco </a>
                <span v-if="showArrow === 'clabe'">
                  <b v-if="sortValues.clabe">↑</b>
                  <b v-if="!sortValues.clabe">↓</b>
                </span>
              </th>
              <th>
                <a href="#"
                  @click.prevent="sortFunction('-amount', 'amount')" v-if="sortValues.amount">
                  Monto</a>
                <a href="#"
                  @click.prevent="sortFunction('amount', 'amount')" v-if="!sortValues.amount">
                  Monto </a>
                <span v-if="showArrow === 'amount'">
                  <b v-if="sortValues.amount">↑</b>
                  <b v-if="!sortValues.amount">↓</b>
                </span>
              </th>
              <th>
                <a href="#"
                  @click.prevent="sortFunction('-created_at', 'created_at')" v-if="sortValues.created_at">
                  Fecha</a>
                <a href="#"
                  @click.prevent="sortFunction('created_at', 'created_at')" v-if="!sortValues.created_at">
                  Fecha</a>
                <span v-if="showArrow === 'created_at'">
                  <b v-if="sortValues.created_at">↑</b>
                  <b v-if="!sortValues.created_at">↓</b>
                </span>
              </th>
              <th>
                <a href="#"
                  @click.prevent="sortFunction('-status', 'status')" v-if="sortValues.status">
                  Estatus</a>
                <a href="#"
                  @click.prevent="sortFunction('status', 'status')" v-if="!sortValues.status">
                  Estatus</a>
                <span v-if="showArrow === 'status'">
                  <b v-if="sortValues.status">↑</b>
                  <b v-if="!sortValues.status">↓</b>
                </span>
              </th>
            </tr>
            <tr v-for="(withdrawal, index) in list.results" :key="index">
              <td>{{ withdrawal.clabe }}</td>
              <td>{{ withdrawal.bank_name }}</td>
              <td>{{ formatCurrency(withdrawal.amount) }}</td>
              <td>{{ dateFormat(withdrawal.created_at) }}</td>
              <td>{{ states[withdrawal.status]}}</td>
               </tr>
          </table>
          <p class="-centered-info"><small>{{ currentPage }} de {{ totalPages }}</small></p>
        </div>
        <p>*Si el estatus es completado espera 15 minutos para verlo reflejado en tu estado de cuenta.</p>
        <div class="table-pagination -centered-info">
          <button
            class="button button-small"
            @click="paginationTable(list.previous, 'previous')"
            :disabled="list.previous === null">Anterior</button>
          <button
            class="button button-small"
            @click="paginationTable(list.next)"
            :disabled="list.next === null">Siguiente</button>
        </div>
      </div>
      <div class="box-no-investments -centered-info" v-if="emptywithdrawal">
       <h4 class="maintitle">No tienes ningún retiro de la cuenta virtual</h4>
       <button class="button"
         @click="$modal.show('virtualaccounts-debits')"
         v-if="$store.getters.getUserBalance.balance > 0"
       >Solicitar retiro</button>
      <modal
       name="virtualaccounts-debits"
       classes="modal-investment v--modal-box v--modal"
       height="auto" width="100%" :maxWidth="600" :adaptive="true">
        <DashboardVirtualAccountsModalDebit
          v-on:updateTableWithdrawal = 'getUserWithdrawal'
        >
        </DashboardVirtualAccountsModalDebit>
      </modal>
      </div>
    </div>
  </transition>
</template>
<script>
import DashboardVirtualAccountsModalDebit
  from '@/views/dashboardVirtualAccount/DashboardVirtualAccountsModalDebit'

import Preloader from '@/components/Preloader'

import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'
export default {
  name: 'UserProfileWithdrawal',
  data () {
    return {
      list: [],
      emptywithdrawal: false,
      totalPages: 1,
      currentPage: 1,
      status: false,
      updateTableWithdrawal: false,
      sortValues: {
        amount: false,
        created_at: false,
        status: false,
        clabe: false,
        order: '-created_at'
      },
      states: {
        pending: 'pendiente',
        cancelled: 'cancelado',
        done: 'completado'
      },
      showArrow: null
    }
  },
  mixins: [mixins, httpRequestMixin],
  components: {
    Preloader,
    DashboardVirtualAccountsModalDebit
  },
  methods: {
    sortFunction: function (value, field) {
      if (!field) for (let i in this.sortValues) this.sortValues[i] = false

      this.sortValues[field] = !this.sortValues[field]
      this.getUserWithdrawal(value, field)

      this.showArrow = field
    },
    getUserWithdrawal: async function (value) {
      this.sortValues.order = value

      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/withdraw/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          limit: 5,
          ordering: value
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.status = true
        this.list = response.data
        if (this.list.count >= 5) {
          this.currentPage = 1
          this.totalPages = Math.ceil(this.list.count / 5)
        }
        if (this.list.results.length === 0) {
          this.emptywithdrawal = true
        } else {
          this.emptywithdrawal = false
        }
      }
    }
  },
  created: function () {
    this.getUserWithdrawal(this.sortValues.order)
  }
}
</script>
<style lang="scss" scoped>
.-margin-top-3 {
  margin-top: 3rem;
}
.table-pagination {
  margin-top: 2rem;
}

.table-style {
  td,
  th {
    font-size: .9em;
    line-height: 1.2;
  }
  th b {
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboardVirtualAccount/DashboardVirtualAccountsWithdrawal.vue